import { render, staticRenderFns } from "./BHPandAction.vue?vue&type=template&id=416c5fca&scoped=true"
import script from "./BHPandAction.vue?vue&type=script&lang=js"
export * from "./BHPandAction.vue?vue&type=script&lang=js"
import style0 from "./BHPandAction.vue?vue&type=style&index=0&id=416c5fca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "416c5fca",
  null
  
)

export default component.exports